import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_NOTETYPENOTES_LOAD_BY_INSTITUTIONID,
    ACTION_NOTETYPENOTES_LOAD_BY_PERSONNELID,
    ACTION_NOTETYPENOTES_LOAD_BY_TRIALID,
    ACTION_NOTETYPENOTES_LOAD_BY_TRIALINSTITUTIONID,
    INoteTypeNotesLoadByInstitutionIdAction,
    INoteTypeNotesLoadByPersonnelIdAction,
    INoteTypeNotesLoadByTrialIdAction,
    INoteTypeNotesLoadByTrialInstitutionIdAction,
    INoteTypeNotesLoadFailureAction,
    INoteTypeNotesLoadSuccessAction,
    LoadFailure,
    LoadSuccess,
} from "../actions/noteTypeNotes";
import { noteTypeNotesApi } from 'src/services/noteTypeNotes';

export const
    getNoteTypeNotesByTrialIdEpic = (action$): Observable<INoteTypeNotesLoadSuccessAction | INoteTypeNotesLoadFailureAction> => {
        return action$
            .ofType(ACTION_NOTETYPENOTES_LOAD_BY_TRIALID)
            .mergeMap((action: INoteTypeNotesLoadByTrialIdAction) => {
                return noteTypeNotesApi
                    .getNoteTypeNotesByTrialId(action.trialId)
                    .map(response =>
                        LoadSuccess(response.noteTypeNotes, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getNoteTypeNotesByTrialInstitutionIdEpic = (action$): Observable<INoteTypeNotesLoadSuccessAction | INoteTypeNotesLoadFailureAction> => {
        return action$
            .ofType(ACTION_NOTETYPENOTES_LOAD_BY_TRIALINSTITUTIONID)
            .mergeMap((action: INoteTypeNotesLoadByTrialInstitutionIdAction) => {
                return noteTypeNotesApi
                    .getNoteTypeNotesByTrialInstitutionId(action.trialInstitutionId)
                    .map(response =>
                        LoadSuccess(response.noteTypeNotes, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getNoteTypeNotesByInstitutionIdEpic = (action$): Observable<INoteTypeNotesLoadSuccessAction | INoteTypeNotesLoadFailureAction> => {
        return action$
            .ofType(ACTION_NOTETYPENOTES_LOAD_BY_INSTITUTIONID)
            .mergeMap((action: INoteTypeNotesLoadByInstitutionIdAction) => {
                return noteTypeNotesApi
                    .getNoteTypeNotesByInstitutionId(action.institutionId)
                    .map(response =>
                        LoadSuccess(response.noteTypeNotes, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getNoteTypeNotesByPersonnelIdEpic = (action$): Observable<INoteTypeNotesLoadSuccessAction | INoteTypeNotesLoadFailureAction> => {
        return action$
            .ofType(ACTION_NOTETYPENOTES_LOAD_BY_PERSONNELID)
            .mergeMap((action: INoteTypeNotesLoadByPersonnelIdAction) => {
                return noteTypeNotesApi
                    .getNoteTypeNotesByPersonnelId(action.personnelId)
                    .map(response =>
                        LoadSuccess(response.noteTypeNotes, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    }